import * as React from 'react';
import { PriceType } from "../../../classes/price-type"
import Toggle from "../../../common/toggle/toggle"
import CheckboxGroup from "../../../common/checkbox/checkbox-group"
import { SeatingOption, IOptionGroup, IOption, SeatingOptionGroup } from '../../../classes/seating-option';
import { sortPriceTypes } from '../../../helpers/price-type-helpers';

interface IPriceTypeFilterProps {
    additionalSeatingOptions: Array<SeatingOptionGroup>;
    onSpecialSeatingToggle: (selectedOptions: IOption[]) => void;
    selectedSpecialSeatingIds: Array<string>;
    description: string;
    allTicketsText: string;
    singleFilter: boolean;
}

export default class SpecialSeatingFilter extends React.PureComponent<IPriceTypeFilterProps, {}> {

    private specialSeatingOptions: Array<IOption>;

    constructor(props: IPriceTypeFilterProps) {
        super(props);

        this.specialSeatingOptions = props.additionalSeatingOptions.map(seatingOption => {
            let opt: IOption = {
                id: seatingOption.id,
                name: seatingOption.name,
                selected: props.selectedSpecialSeatingIds.indexOf(seatingOption.id) >= 0
            };
            return opt;
        });
    }

    render() {
        return (
            <div className="price-type-filter">
                <div className={`price-type-filter-list ${(!this.props.singleFilter ? "combine-filters" : "")}`}>
                    {
                        <CheckboxGroup group={{
                            options: this.specialSeatingOptions,
                            name: "specialSeatingFilter"
                        } as IOptionGroup}
                            allText={this.props.allTicketsText}
                            showAllOption={this.props.singleFilter}
                            selectedOptions={this.specialSeatingOptions.filter(option => this.props.selectedSpecialSeatingIds.indexOf(option.id) >= 0)}
                            stateChangeFunction={this.props.onSpecialSeatingToggle} id={null} />
                    }
                </div>
            </div>
        )
    }
}